/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { FollowUpConfigurationFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateFollowUpConfigurationInput = {
  isActive?: boolean | null
  label?: string | null
  position?: number | null
  sourceProductName: string
  targetProductName: string
}

export type UpdateFollowUpConfigurationInput = {
  isActive?: boolean | null
  label?: string | null
  position?: number | null
}

export type CreateFollowUpConfigurationMutationVariables = Exact<{
  input: Types.CreateFollowUpConfigurationInput
}>

export type CreateFollowUpConfigurationMutation = {
  __typename: "Mutation"
  followUpConfiguration: {
    __typename: "FollowUpConfiguration"
    id: string
    position: number
    isActive?: boolean | null
    sourceProduct: {
      __typename: "DimConfiguration"
      id: string
      productName: string
      productType: string
      isActive?: boolean | null
      dimensioningKey?: string | null
    }
    targetProduct: {
      __typename: "DimConfiguration"
      id: string
      productName: string
      productType: string
      isActive?: boolean | null
      dimensioningKey?: string | null
    }
  }
}

export type UpdateFollowUpConfigurationMutationVariables = Exact<{
  id: string
  input: Types.UpdateFollowUpConfigurationInput
}>

export type UpdateFollowUpConfigurationMutation = {
  __typename: "Mutation"
  followUpConfiguration: {
    __typename: "FollowUpConfiguration"
    id: string
    position: number
    isActive?: boolean | null
    sourceProduct: {
      __typename: "DimConfiguration"
      id: string
      productName: string
      productType: string
      isActive?: boolean | null
      dimensioningKey?: string | null
    }
    targetProduct: {
      __typename: "DimConfiguration"
      id: string
      productName: string
      productType: string
      isActive?: boolean | null
      dimensioningKey?: string | null
    }
  }
}

export type DeleteFollowUpConfigurationMutationVariables = Exact<{
  id: string
}>

export type DeleteFollowUpConfigurationMutation = {
  __typename: "Mutation"
  followUpConfiguration: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateFollowUpConfigurationDocument = gql`
  mutation CreateFollowUpConfiguration(
    $input: CreateFollowUpConfigurationInput!
  ) {
    followUpConfiguration: createFollowUpConfiguration(input: $input)
      @rest(
        endpoint: "followUpConfiguration"
        type: "FollowUpConfiguration"
        method: "POST"
        path: "/dimensioning-data-exchange/follow-up-configuration"
      ) {
      ...FollowUpConfiguration
    }
  }
  ${FollowUpConfigurationFragmentDoc}
`
export type CreateFollowUpConfigurationMutationFn = Apollo.MutationFunction<
  CreateFollowUpConfigurationMutation,
  CreateFollowUpConfigurationMutationVariables
>

/**
 * __useCreateFollowUpConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateFollowUpConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFollowUpConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFollowUpConfigurationMutation, { data, loading, error }] = useCreateFollowUpConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFollowUpConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFollowUpConfigurationMutation,
    CreateFollowUpConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateFollowUpConfigurationMutation,
    CreateFollowUpConfigurationMutationVariables
  >(CreateFollowUpConfigurationDocument, options)
}
export type CreateFollowUpConfigurationMutationHookResult = ReturnType<
  typeof useCreateFollowUpConfigurationMutation
>
export type CreateFollowUpConfigurationMutationResult =
  Apollo.MutationResult<CreateFollowUpConfigurationMutation>
export type CreateFollowUpConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateFollowUpConfigurationMutation,
    CreateFollowUpConfigurationMutationVariables
  >
export const UpdateFollowUpConfigurationDocument = gql`
  mutation UpdateFollowUpConfiguration(
    $id: ID!
    $input: UpdateFollowUpConfigurationInput!
  ) {
    followUpConfiguration: updateFollowUpConfiguration(id: $id, input: $input)
      @rest(
        endpoint: "followUpConfiguration"
        type: "FollowUpConfiguration"
        method: "PUT"
        path: "/dimensioning-data-exchange/follow-up-configuration/{args.id}"
      ) {
      ...FollowUpConfiguration
    }
  }
  ${FollowUpConfigurationFragmentDoc}
`
export type UpdateFollowUpConfigurationMutationFn = Apollo.MutationFunction<
  UpdateFollowUpConfigurationMutation,
  UpdateFollowUpConfigurationMutationVariables
>

/**
 * __useUpdateFollowUpConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateFollowUpConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFollowUpConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFollowUpConfigurationMutation, { data, loading, error }] = useUpdateFollowUpConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFollowUpConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFollowUpConfigurationMutation,
    UpdateFollowUpConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateFollowUpConfigurationMutation,
    UpdateFollowUpConfigurationMutationVariables
  >(UpdateFollowUpConfigurationDocument, options)
}
export type UpdateFollowUpConfigurationMutationHookResult = ReturnType<
  typeof useUpdateFollowUpConfigurationMutation
>
export type UpdateFollowUpConfigurationMutationResult =
  Apollo.MutationResult<UpdateFollowUpConfigurationMutation>
export type UpdateFollowUpConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateFollowUpConfigurationMutation,
    UpdateFollowUpConfigurationMutationVariables
  >
export const DeleteFollowUpConfigurationDocument = gql`
  mutation DeleteFollowUpConfiguration($id: ID!) {
    followUpConfiguration: deleteFollowUpConfiguration(id: $id)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/dimensioning-data-exchange/follow-up-configuration/{args.id}"
      ) {
      success
    }
  }
`
export type DeleteFollowUpConfigurationMutationFn = Apollo.MutationFunction<
  DeleteFollowUpConfigurationMutation,
  DeleteFollowUpConfigurationMutationVariables
>

/**
 * __useDeleteFollowUpConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteFollowUpConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFollowUpConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFollowUpConfigurationMutation, { data, loading, error }] = useDeleteFollowUpConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFollowUpConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFollowUpConfigurationMutation,
    DeleteFollowUpConfigurationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteFollowUpConfigurationMutation,
    DeleteFollowUpConfigurationMutationVariables
  >(DeleteFollowUpConfigurationDocument, options)
}
export type DeleteFollowUpConfigurationMutationHookResult = ReturnType<
  typeof useDeleteFollowUpConfigurationMutation
>
export type DeleteFollowUpConfigurationMutationResult =
  Apollo.MutationResult<DeleteFollowUpConfigurationMutation>
export type DeleteFollowUpConfigurationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteFollowUpConfigurationMutation,
    DeleteFollowUpConfigurationMutationVariables
  >
